<div class="flex min-h-screen bg-white">
  <!-- Partie gauche - Image -->
  <div class="w-1/2 hidden md:block image-container">
    <img src="assets/Innov.png" alt="Innov Impact Africa"
      class="object-cover w-[678] h-[910] mx-auto py-4" />
  </div>
  
  <!-- Partie droite - Formulaire -->
  <div class="w-full md:w-1/2 flex flex-col justify-center px-8 py-12">
    <div class="max-w-lg mx-auto w-full">
      <!-- Alerte -->
      <div *ngIf="currentAlert.show" class="mb-4 p-4 rounded-lg" [ngClass]="{
             'bg-green-100 border border-green-400 text-green-700': currentAlert.type === 'success',
             'bg-red-100 border border-red-400 text-red-700': currentAlert.type === 'error',
             'bg-yellow-100 border border-yellow-400 text-yellow-700': currentAlert.type === 'warning'
           }">
        {{ currentAlert.message }}
      </div>

      <!-- Bouton de retour -->
      <div class="mb-6">
        <button (click)="navigateToLogin()"
          class="flex items-center bg-gray-100 justify-center w-10 h-10 lg:w-12 lg:h-12 border border-gray-300 rounded-lg transition-colors hover:bg-gray-200">
          <svg class="w-5 h-5 lg:w-6 lg:h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
          </svg>
        </button>
      </div>

      <!-- Titre et description -->
      <div class="mx-auto mb-8">
        <h1 class="text-4xl font-bold text-gray-800 mb-2">Mot de passe oublié ?</h1>
        <p class="text-lg text-gray-600">Entrez votre email pour recevoir les instructions de réinitialisation</p>
      </div>

      <!-- Formulaire de réinitialisation -->
      <form [formGroup]="currentRequestForm" (ngSubmit)="onRequestCode()">
        <div class="mb-6">
          <label for="email" class="block text-gray-700 font-medium mb-2">Email</label>
          <input 
            type="email" 
            id="email" 
            formControlName="email" 
            placeholder="Entrez votre email"
            class="w-full px-4 py-3 rounded-lg focus:outline-none focus:ring-2 border border-gray-300 transition-all"
            style="focus-border-color: #063970; --tw-ring-color: #063970"
            [class.border-red-500]="currentRequestForm.get('email')?.invalid && currentRequestForm.get('email')?.touched" />
          <div *ngIf="currentEmailError" class="text-red-500 text-sm mt-1 flex items-center gap-1">
            <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
            </svg>
            {{ currentEmailError }}
          </div>
        </div>

        <button 
          type="submit" 
          [disabled]="currentIsLoading"
          class="w-full text-white py-3 rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
          [style.background]="currentIsLoading ? 'linear-gradient(to right, #4a6fa5, #5a7fb5)' : 'linear-gradient(to right, #063970, #084a8c)'"
          [style.opacity]="currentIsLoading ? 0.7 : 1">
          <span *ngIf="!currentIsLoading">Envoyer le lien de réinitialisation</span>
          <span *ngIf="currentIsLoading" class="flex items-center justify-center gap-2">
            <svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Envoi en cours...
          </span>
        </button>
      </form>

      <!-- Lien retour vers la connexion -->
      <div class="text-center mt-6">
        <p class="text-sm text-gray-600">
          Vous vous souvenez de votre mot de passe ?
          <a routerLink="/login" class="font-medium underline transition-colors" style="color: #063970">
            Se connecter
          </a>
        </p>
      </div>

      <!-- Logo en bas de page -->
      <div class="mt-12 text-center">
        <img src="assets/images/UKUBHALISA.png" alt="Logo UKUBHALISA" class="mx-auto w-[74px] h-[39px]" />
      </div>
    </div>
  </div>
</div>